import React from 'react'

const Midcontent = () => {
  return (
    <div>
      
    </div>
  )
}

export default Midcontent
